// extracted by mini-css-extract-plugin
module.exports = {"section":"MarriageWsHeader_section_2CtXn","text-red":"MarriageWsHeader_text-red_3VI4l"};